<template>
	<div class="dc-post-grid-filters-wrapper">
		<!-- Static search is depricated. Use flexible component search instead. -->
		<div
			:class="['dc-post-grid-search-wrapper']"
			v-if="searchFormPlaceholder && !filters.some((f) => f.name === 'search')"
		>
			<SearchFilter
				:model="form.dc_s"
				:searchFormPlaceholder="searchFormPlaceholder"
				v-on:updateSearchTerm="updateSearchTerm"
			/>
		</div>
		<!-- Deprication end -->

		<div v-if="filters" :class="['dc-post-grid-dropdowns-wrapper']">
			<!-- Static label is depricated. Use flexible component label instead. -->
			<h3 v-if="filterLabel && !filters.some((f) => f.name === 'label')">{{ filterLabel }}</h3>
			<!-- Deprication end -->

			<div v-for="filter in filters" :key="'filter-' + filter.name">
				<h3 v-if="filter.name === 'label'">{{ filter.value }}</h3>

				<div
					:class="['dc-post-grid-search-wrapper']"
					v-else-if="filter.type === 'default' && filter.name === 'search'"
				>
					<SearchFilter
						:model="filter.value ? filter.value : form.dc_s"
						:searchFormPlaceholder="filter.placeholder"
						v-on:updateSearchTerm="updateSearchTerm"
					/>
				</div>

				<Dropdown
					v-else-if="filter.type === 'default'" 
					:disabled="disabledFilters.includes(filter.name)"
					:label="filter.label"
					:name="filter.name"
					:options="filter.options"
					:model="form[filter.name] || []"
					:multiselect="(typeof filter.multiselect !== undefined && filter.multiselect == 0) ? false : true"
					:initialSelection="filter.initial_selection"
					:showAllOption="filter.show_all_option"
					:gridSettings="gridSettings"
					:open="filter.name === openFilter"
					v-on:toggle-filter="toggleFilter"
					v-on:update-filter="updateAndSearch"
					v-on:reset-filter="resetAndSearch"
				/>
			</div>
		</div>

		<input
			v-on:click.stop.prevent="search"
			:id="searchButtonId"
			type="submit"
			tabindex="-1"
			:class="['screen-reader-text', { loading: loading }]"
			:value="dctxt( 'search' )"
		/>
	</div>
</template>

<script>
import SearchFilter from '@dc-post-grid/layout/Search';
import Dropdown from '@dc-post-grid/layout/filters/Dropdown';
import { Searchable } from '@dc-post-grid/mixins/Searchable';
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [Searchable, Translatable],
	data() {
		return {
			openFilter: null,
			minHeight: 0,
			form: {
				dc_s: this?.initialModel?.dc_s || '',
				paged: 2,
				category: [],
			},
		};
	},
	props: {
		searchFormPlaceholder: {
			type: String,
			required: false,
			default: '',
		},
		filterLabel: {
			type: String,
			required: false,
			default: '',
		},
		gridSettings: {
			type: Object,
			required: false,
			default: {},
		},
		initialModel: {
			type: Object,
			required: false,
			default: {},
		},
		loading: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		updateFilter(name, newValue, usesMultiselect) {
			this.$emit('update-filter', name, newValue);
		},
		toggleFilter(name, targetDropdownId) {
			this.openFilter = this.openFilter === name ? null : name;
			if (this.openFilter === null) {
				this.$emit('update-post-grid-min-height', 0);
			} else {
				window.setTimeout(() => {
					const dropdownOptions = document.getElementById(targetDropdownId);
					this.$emit('update-post-grid-min-height', dropdownOptions.clientHeight);
				}, 500);
			}
		},
	},
	components: {
		Dropdown,
		SearchFilter,
	},
};
</script>
